import * as colors from '../../theme/colors';

export const wrapper = {
  position: 'relative',
  display: 'inline-block',
  marginLeft: 'auto',
  alignSelf: 'flex-start',
};

export const button = {
  height: '32px',
  padding: '0 12px',
  border: `1px solid ${colors.grayLight}`,
  borderRadius: '4px',
  backgroundColor: '#fff',
  color: colors.grayDark,
  fontSize: '14px',
  fontFamily: 'inherit',
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  '&:hover': {
    borderColor: colors.gray,
  },
  '&:disabled': {
    opacity: 0.6,
    cursor: 'not-allowed',
  },
};

export const dropdown = {
  position: 'absolute',
  top: '36px',
  right: 0,
  zIndex: 9000,
  backgroundColor: '#fff',
  border: `1px solid ${colors.grayLight}`,
  borderRadius: '4px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
  minWidth: '210px',
  overflow: 'hidden',
};

export const option = {
  display: 'block',
  width: '100%',
  padding: '8px 16px',
  border: 'none',
  backgroundColor: 'transparent',
  textAlign: 'left',
  fontSize: '14px',
  color: colors.grayDark,
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: colors.gray10,
  },
};

export const error = {
  display: 'block',
  marginTop: '4px',
  fontSize: '12px',
  color: '#c0392b',
};
